// Constants for Core Tracking (Phase 3)

export const CORE_STATUSES = {
  pending_return: { label: "Pending Return", color: "text-amber-700", bg: "bg-amber-100" },
  returned: { label: "Returned", color: "text-blue-700", bg: "bg-blue-100" },
  credit_pending: { label: "Credit Pending", color: "text-indigo-700", bg: "bg-indigo-100" },
  credit_received: { label: "Credit Received", color: "text-green-700", bg: "bg-green-100" },
  closed: { label: "Closed", color: "text-slate-600", bg: "bg-slate-100" },
  lost: { label: "Lost", color: "text-red-700", bg: "bg-red-100" },
};

// Allowed next statuses (workflow)
export const CORE_NEXT = {
  pending_return: ["returned", "lost"],
  returned: ["credit_pending", "credit_received", "lost"],
  credit_pending: ["credit_received", "lost"],
  credit_received: ["closed"],
};

export const ESCALATION = {
  ok: { label: "On Track", color: "text-slate-600", bg: "bg-slate-100", border: "border-slate-200", ring: "" },
  warning: { label: "Warning (>14d)", color: "text-amber-700", bg: "bg-amber-50", border: "border-amber-300", ring: "ring-1 ring-amber-200" },
  high: { label: "High Priority (>30d)", color: "text-orange-700", bg: "bg-orange-50", border: "border-orange-300", ring: "ring-1 ring-orange-300" },
  escalation: { label: "Escalation (>60d)", color: "text-red-700", bg: "bg-red-50", border: "border-red-400", ring: "ring-2 ring-red-300" },
};
